// @ts-nocheck

import { HeadingTag, TemplateType, Theme } from '@/common/pd-meta-components-types'
import { requestV2 } from './request'
import qs from 'qs'
import { findRegionByLocale } from '@/common/region-locale'
import type { MediaAlt } from '@/common/media-alt'

// 通用图片/视频等媒体类型
export interface MediaUrl {
  documentId: string
  id: number
  url: string
  alts?: MediaAlt[] | null
}

// description 里的所有组件类型联合
export type ProductDescriptionComponent =
  | ProductInfoF0
  | ProductInfoF11
  | ProductInfoF12
  | ProductInfoF13
  | ProductInfoF14
  | ProductInfoF15
  | ProductInfoF21
  | ProductInfoF31
  | ProductInfoF32
  | ProductInfoF4
  | ProductInfoF51
  | ProductInfoF52
  | ProductInfoF61
  | ProductInfoF62
  | ProductInfoF71
  | ProductInfoF72
  | ProductInfoF73
  | ProductInfoF74
  | ProductInfoC1
  | ProductInfoC2
  | ProductInfoC21
  | ProductInfoC22
  | ProductInfoC3
  | ProductInfoC4
  | ProductInfoC5
  | ProductInfoC6
  | ProductInfoC7
  | ProductInfoS1
  | ProductInfoS2
  | ProductInfoS3
  | ProductInfoS4

//#region 产品详情页组件类型
export interface ProductInfoF0 {
  __component: 'product-info.f0'
  id: number
  maskColor: string
  maskDegree: number
  mediaH5Url: MediaUrl | null
  mediaUrl: MediaUrl | null
  subTitle: string
  subTitleTag: HeadingTag | null
  theme: Theme
  titleUrl: MediaUrl | null
  videoUrl: MediaUrl | null
}

export interface ProductInfoF11 {
  __component: 'product-info.f1-1'
  id: number
  desc: string
  maskColor: string
  maskDegree: number
  mediaH5Url: MediaUrl | null
  mediaUrl: MediaUrl | null
  theme: Theme
  title: string
  titleTag: HeadingTag | null
}

export interface ProductInfoF12 {
  __component: 'product-info.f1-2'
  id: number
  desc: string
  mediaAspectRatio: string
  mediaBorderRadius: number
  mediaGroup: ProductInfoF12MediaGroup[]
  theme: Theme
  title: string
  titleTag: HeadingTag | null
  itemTitleTag: HeadingTag | null
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF12MediaGroup {
  desc: string
  id: number
  infoGroup: ProductInfoF12InfoGroup[]
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoF12InfoGroup {
  data: string
  desc: string
  font_color: string | null
  icon: MediaUrl | null
  id: number
}

export interface ProductInfoF13 {
  __component: 'product-info.f1-3'
  id: number
  desc: string
  mediaAspectRatio: string
  mediaAspectRatioH5?: string
  mediaBorderRadius: number
  mediaGroup: ProductInfoF13MediaGroup[]
  tagGroup: ProductInfoF13TagGroup[]
  theme: Theme
  title: string
  titleTag: HeadingTag | null
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF13MediaGroup {
  desc: string
  id: number
  mediaUrl: MediaUrl | null
  tabTitle: string
}

export interface ProductInfoF13TagGroup {
  desc: string
  icon: MediaUrl | null
  id: number
  title: string
}

export interface ProductInfoF14 {
  __component: 'product-info.f1-4'
  id: number
  desc: string
  mediaH5Url: MediaUrl | null
  mediaUrl: MediaUrl | null
  tagGroup: ProductInfoF14TagGroup[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF14TagGroup {
  desc: string
  id: number
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoF15 {
  __component: 'product-info.f1-5'
  id: number
  desc: string
  mediaH5Url: MediaUrl | null
  mediaUrl: MediaUrl | null
  tagGroup: ProductInfoF15TagGroup[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF15TagGroup {
  desc: string
  id: number
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoF21 {
  __component: 'product-info.f2-1'
  id: number
  desc: string
  mediaAspectRatio: string
  mediaBorderRadius: number
  mediaGroup: ProductInfoF21MediaGroup[]
  theme: Theme
  title: string
  titleTag: HeadingTag | null
  itemTitleTag: HeadingTag | null
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF21MediaGroup {
  /** 单项悬停缩放；未配置或 null 时保持开启。 */
  enableHoverScale?: boolean | null
  desc: string
  fontColor: string | null
  id: number
  mediaH5Url: MediaUrl | null
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoF31 {
  __component: 'product-info.f3-1'
  id: number
  desc: string
  mediaAspectRatio: string | null
  mediaBorderRadius: number
  mediaGroup: ProductInfoF31MediaGroup[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF31MediaGroup {
  desc: string
  fontColor: string | null
  id: number
  mediaH5Url: MediaUrl | null
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoF32 {
  __component: 'product-info.f3-2'
  id: number
  desc: string
  mediaAspectRatio: string
  mediaBorderRadius: number
  mediaGroup: ProductInfoF32MediaGroup[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF32MediaGroup {
  desc: string
  fontColor: string | null
  id: number
  mediaH5Url: MediaUrl | null
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoF4 {
  __component: 'product-info.f4'
  id: number
  desc: string
  mediaAspectRatio: string
  mediaBorderRadius: number
  mediaGroup: ProductInfoF4MediaGroup[]
  theme: Theme | null
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF4MediaGroup {
  desc: string
  fontColor: string | null
  id: number
  mediaH5Url: MediaUrl | null
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoF51 {
  __component: 'product-info.f5-1'
  id: number
  desc: string
  mediaAspectRatio: string
  mediaBorderRadius: number
  mediaGroup: ProductInfoF51MediaGroup[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF51MediaGroup {
  desc: string
  fontColor: string | null
  id: number
  mediaH5Url: MediaUrl | null
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoF52 {
  __component: 'product-info.f5-2'
  id: number
  desc: string
  mediaAspectRatio: string | null
  mediaBorderRadius: number
  mediaGroup: ProductInfoF52MediaGroup[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF52MediaGroup {
  desc: string
  id: number
  mediaH5Url: MediaUrl | null
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoF61 {
  __component: 'product-info.tab-1-f6-1'
  id: number
  desc: string
  mediaBorderRadius?: number
  mediaGroup: ProductInfoF61MediaGroup[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF61MediaGroup {
  desc: string
  downloadTitle: string
  downloadUrl: MediaUrl | null
  jumpUrl: string | null
  id: number
  mediaUrl: MediaUrl | null
  subTitle: string
  tabTitle: string
  title: string
}

export interface ProductInfoF62 {
  __component: 'product-info.tab-2-f6-2'
  id: number
  desc: string
  mediaUrlList: MediaUrl[]
  tabPanels: ProductInfoF62TabPanel[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF62TabPanel {
  id: number
  panel: string
  tab: string
}

export interface ProductInfoF71 {
  __component: 'product-info.icon-1-f7-1'
  id: number
  dataList: ProductInfoF71Data[]
  theme: Theme
  title: string
  align?: 'left' | 'center' | 'right'
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF71Data {
  desc: string | null
  id: number
  mediaUrl: MediaUrl | null
  title: string | null
}

export interface ProductInfoF72 {
  __component: 'product-info.icon-1-f7-2'
  id: number
  dataList: ProductInfoF72Data[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF72Data {
  desc: string | null
  id: number
  mediaUrl: MediaUrl | null
  title: string | null
}

export interface ProductInfoF73 {
  __component: 'product-info.icon-1-f7-3'
  id: number
  dataList: ProductInfoF73Data[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF73Data {
  desc: string | null
  id: number
  mediaUrl: MediaUrl | null
  title: string | null
}

export interface ProductInfoF74 {
  __component: 'product-info.icon-1-f7-4'
  id: number
  dataList: ProductInfoF74Data[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoF74Data {
  desc: string | null
  id: number
  mediaUrl: MediaUrl | null
  title: string | null
}

export interface ProductInfoC1 {
  __component: 'product-info.c1'
  desc: string
  id: number
  mediaBorderRadius?: number
  mediaH5BorderRadius?: number
  theme: Theme
  title: string
  titleTag: HeadingTag | null
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoC2 {
  __component: 'product-info.c2'
  id: number
  desc: string
  borderRadius: number
  mediaGroup: ProductInfoC2MediaGroup[]
  theme: Theme
  title: string
  titleTag: HeadingTag | null
  itemTitleTag: HeadingTag | null
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoC2MediaGroup {
  id: number
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoC21 {
  __component: 'product-info.c2-1'
  id: number
  dataList: ProductInfoC21Data[]
  theme: Theme
  /** 区块顶部间距 - PC 端 px 值，如 "px100" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px100" */
  paddingBottom?: string
}

export interface ProductInfoC21Data {
  borderRadius?: number
  desc: string
  id: number
  items: ProductInfoC21Item[]
  name: string
  subTitle: string
  title: string
}

export interface ProductInfoC21Item {
  color: string | null
  desc: string
  id: number
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoC22 {
  __component: 'product-info.c2-2'
  borderRadius: number
  dataList: ProductInfoC22Data[]
  id: number
  theme: Theme
  /** 区块顶部间距 - PC 端 px 值，如 "px100" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px100" */
  paddingBottom?: string
}

export interface ProductInfoC22Data {
  bottomDesc: string
  bottomSubTitle: string
  bottomTitle: string
  cardList: ProductInfoC22Card[]
  downloadTitle: string
  downloadUrl: string | null
  id: number
  tabTitle: string
}

export interface ProductInfoC22Card {
  desc: string | null
  id: number
  media: MediaUrl | null
  modalDesc: string | null
  modalMediaGroup: ProductInfoC22ModalMedia[]
  modalTitle: string | null
  textColor: string | null
  title: string | null
}

export interface ProductInfoC22ModalMedia {
  desc: string
  id: number
  media: MediaUrl | null
  title: string
}

export interface ProductInfoC3 {
  __component: 'product-info.c3'
  btnText: string
  id: number
  imageUrl: MediaUrl | null
  paramsList: ProductInfoC3Params[]
  robot: string
  theme: Theme
  title: string
  titleTag: HeadingTag | null
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoC3Params {
  id: number
  title: string
  value: { id: number; title: string }[]
}

export interface ProductInfoC4 {
  __component: 'product-info.c4'
  dataList: ProductInfoC4Data[]
  id: number
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px64" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px64" */
  paddingBottom?: string
}

export interface ProductInfoC4Data {
  id: number
  title: string
}

export interface ProductInfoC5 {
  __component: 'product-info.c5'
  aspectRatio: string
  borderRadius: string
  desc: string
  id: number
  mediaGroup: MediaUrl[]
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px0" */
  paddingBottom?: string
}

export interface ProductInfoC6 {
  __component: 'product-info.c6'
  dataList: ProductInfoC6Data[]
  desc: string
  id: number
  robotCode: string
  showColor?: boolean
  theme: Theme
  title: string
  /** 区块顶部间距 - PC 端 px 值，如 "px120" */
  paddingTop?: string
  /** 区块底部间距 - PC 端 px 值，如 "px120" */
  paddingBottom?: string
}

export interface ProductInfoC6Data {
  colors: ProductInfoC6Color[]
  defaultActiveColor: string
  id: number
  introduceArr: { title: string; desc: string }[]
  title: string
}

export interface ProductInfoC6Color {
  color: string
  id: number
  imgUrl: MediaUrl
}

export interface ProductInfoC7 {
  __component: 'product-info.c7'
  buttonText: string
  buttonTextColor: string
  buttonTextSize: 'default' | 'large' | 'small'
  color: string
  hideCircleBorder: boolean
  href: string
  id: number
  robot: MediaUrl
}

export interface ProductInfoS1 {
  __component: 'product-info.s1'
  desc: string
  id: number
  innerMediaUrlList: MediaUrl[]
  productMedia: MediaUrl
  theme: Theme
  title: string
}

export interface ProductInfoS2 {
  __component: 'product-info.s2'
  desc: string
  id: number
  infoItemList: ProductInfoS2InfoItem[]
  mediaUrlList: MediaUrl[]
  theme: Theme
  title: string
}

export interface ProductInfoS2InfoItem {
  desc: string
  id: number
  title: string | null
}

export interface ProductInfoS3 {
  __component: 'product-info.s3'
  desc: string
  id: number
  mediaAspectRatio: string | null
  mediaBorderRadius: number | null
  mediaGroup: ProductInfoS3MediaGroup[]
  theme: Theme
  title: string
}

export interface ProductInfoS3MediaGroup {
  desc: string
  id: number
  mediaUrl: MediaUrl | null
  title: string
}

export interface ProductInfoS4 {
  __component: 'product-info.s4'
  desc: string
  id: number
  mediaUrl: MediaUrl
  tagList: ProductInfoS4Tag[]
  theme: Theme
  title: string
  titleTag: HeadingTag | null
  itemTitleTag: HeadingTag | null
}

export interface ProductInfoS4Tag {
  id: number
  mediaUrl: MediaUrl
  title: string
}
//#endregion

export interface ProductBaseData {
  createdAt: string
  desc: string | null
  description: ProductDescriptionComponent[]
  documentId: string
  id: number
  jump_url: string
  key: string
  locale: string
  name: string
  publishedAt: string
  updatedAt: string
  useDescription: boolean
}

export type ProductDetailData = ProductDescriptionComponent[]

// 顶层数据结构
export interface ProductApiResponse {
  data: ProductBaseData[]
  meta: {
    pagination: {
      page: number
      pageCount: number
      pageSize: number
      total: number
    }
  }
}

// 后台组件动态填充查询参数
const componentDataMap = {
  [TemplateType.F0]: {
    populate: {
      mediaUrl: { fields: ['url', 'alts'] },
      mediaH5Url: { fields: ['url', 'alts'] },
      titleUrl: { fields: ['url'] },
      videoUrl: { fields: ['url'] },
    },
  },
  [TemplateType.F11]: {
    populate: {
      mediaUrl: { fields: ['url'] },
      mediaH5Url: { fields: ['url'] },
    },
  },
  [TemplateType.F12]: {
    populate: {
      mediaGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
          infoGroup: {
            populate: {
              icon: { fields: ['url'] },
            },
          },
        },
      },
    },
  },
  [TemplateType.F13]: {
    populate: {
      tagGroup: {
        populate: {
          icon: { fields: ['url'] },
        },
      },
      mediaGroup: {
        fields: ['tabTitle', 'desc'],
        populate: {
          mediaUrl: { fields: ['url'] },
          mediaH5Url: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.F14]: {
    populate: {
      mediaUrl: { fields: ['url'] },
      mediaH5Url: { fields: ['url'] },
      tagGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.F15]: {
    populate: {
      mediaUrl: { fields: ['url'] },
      mediaH5Url: { fields: ['url'] },
      tagGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.F21]: {
    populate: {
      mediaGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
          mediaH5Url: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.F31]: {
    populate: {
      mediaGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
          mediaH5Url: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.F32]: {
    populate: {
      mediaGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
          mediaH5Url: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.F4]: {
    populate: {
      mediaGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
          mediaH5Url: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.F51]: {
    populate: {
      mediaGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
          mediaH5Url: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.F52]: {
    populate: {
      mediaGroup: {
        fields: ['title', 'desc'],
        populate: {
          mediaUrl: { fields: ['url'] },
          mediaH5Url: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.F61]: {
    populate: {
      mediaGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
          downloadUrl: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.F62]: {
    populate: {
      mediaUrlList: { fields: ['url'] },
      tabPanels: {
        fields: ['tab', 'panel'],
      },
    },
  },
  [TemplateType.F71]: {
    populate: {
      dataList: {
        populate: {
          mediaUrl: {
            fields: ['url'],
          },
        },
      },
    },
  },
  [TemplateType.F72]: {
    populate: {
      dataList: {
        populate: {
          mediaUrl: {
            fields: ['url'],
          },
        },
      },
    },
  },
  [TemplateType.F73]: {
    populate: {
      dataList: {
        populate: {
          mediaUrl: {
            fields: ['url'],
          },
        },
      },
    },
  },
  [TemplateType.F74]: {
    populate: {
      dataList: {
        populate: {
          mediaUrl: {
            fields: ['url'],
          },
        },
      },
    },
  },
  [TemplateType.C1]: {
    populate: '*',
  },
  [TemplateType.C2]: {
    populate: {
      mediaGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.C21]: {
    fields: ['theme'],
    populate: {
      dataList: {
        populate: {
          items: {
            populate: {
              mediaUrl: { fields: ['url'] },
            },
          },
        },
      },
    },
  },
  [TemplateType.C22]: {
    populate: {
      dataList: {
        populate: {
          cardList: {
            populate: {
              media: {
                fields: ['url'],
              },
              modalMediaGroup: {
                populate: {
                  media: {
                    fields: ['url'],
                  },
                },
              },
            },
          },
          downloadUrl: {
            fields: ['url'],
          },
        },
      },
    },
  },
  [TemplateType.C3]: {
    populate: {
      imageUrl: { fields: ['url'] },
      paramsList: {
        populate: {
          value: {
            fields: ['title'],
          },
        },
      },
    },
  },
  [TemplateType.C4]: {
    populate: {
      dataList: {
        fields: ['title'],
      },
    },
  },
  [TemplateType.C5]: {
    populate: {
      mediaGroup: { fields: ['url'] },
    },
  },
  [TemplateType.C6]: {
    populate: {
      dataList: {
        populate: {
          colors: {
            populate: {
              imgUrl: { fields: ['url'] },
            },
          },
          introduceArr: true,
        },
      },
    },
  },
  [TemplateType.C7]: {
    populate: {
      robot: {
        fields: ['url'],
      },
    },
  },
  [TemplateType.S1]: {
    populate: {
      productMedia: { fields: ['url'] },
      innerMediaUrlList: { fields: ['url'] },
    },
  },
  [TemplateType.S2]: {
    populate: {
      infoItemList: true,
      mediaUrlList: { fields: ['url'] },
    },
  },
  [TemplateType.S3]: {
    populate: {
      mediaGroup: {
        populate: {
          mediaUrl: { fields: ['url'] },
        },
      },
    },
  },
  [TemplateType.S4]: {
    populate: {
      mediaUrl: { fields: ['url'] },
      tagList: {
        populate: {
          mediaUrl: { fields: ['url'] },
        },
      },
    },
  },
}

// 生成组件查询参数
const generateQuery = (components: TemplateType[]) => {
  const componentTypeMap: Partial<Record<TemplateType, any>> = {}
  components.forEach((component) => {
    componentTypeMap[component] = componentDataMap[component]
  })
  return qs.stringify(
    {
      populate: {
        description: {
          on: componentTypeMap,
        },
      },
    },
    { encodeValuesOnly: true }
  )
}

export async function getProductBaseData(productId: string, locale?: string): Promise<ProductBaseData> {
  const payload = {
    url: `/api/products/?filters[key][$eq]=${productId}&status=published`,
  }

  if (locale) {
    const region = findRegionByLocale(locale)
    payload.region = region
  }

  const res = await requestV2('/common/data', payload)
  return res.data[0]
}

getProductBaseData.swrkey = (locale: string, productId: string) =>
  `/base/${locale}/api/front/v2/common/data/products/${productId}`

export async function getProductDetailData(productId: string, locale?: string): Promise<ProductDescriptionComponent[]> {
  const payload = {
    url: `/api/products/?filters[key][$eq]=${productId}&populate[description]=1&status=published`,
  }

  if (locale) {
    const region = findRegionByLocale(locale)
    payload.region = region
  }

  // 获取产品配置的所有组件
  const res1 = await requestV2('/common/data', payload)
  if (!res1.data || !res1.data[0] || !res1.data[0].description) {
    return []
  }
  const components = res1.data[0].description.map((item: { __component: TemplateType }) => {
    return item.__component
  })
  const query = generateQuery(components)

  // 获取所有组件数据
  const _payload = {
    url: `/api/products/?filters[key][$eq]=${productId}&${query}&status=published`,
  }
  if (locale) {
    const region = findRegionByLocale(locale)
    _payload.region = region
  }

  const res: ProductApiResponse = await requestV2('/common/data', _payload)

  return res.data[0].description
}

getProductDetailData.swrkey = (locale: string, productId: string) =>
  `/${locale}/api/front/v2/common/data/products/${productId}`
